import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { LogaltySuccess } from '@/Logalty/ui/molecules'
import { navigationRoutes } from '@/Shared/ui/routers'

export const Step5SuccessScreen = (): JSX.Element => {
  const { t } = useTranslation()

  const {
    logalty: { signStatus },
  } = useAutoEnrollment()

  return (
    <LogaltySuccess
      title={t(AutoEnrollmentTranslation.confirmationScreen.success.title)}
      description={t(AutoEnrollmentTranslation.confirmationScreen.success.description)}
      buttonLabel={t(AutoEnrollmentTranslation.confirmationScreen.success.button.label)}
      signStatus={signStatus}
      returnRoute={navigationRoutes.home}
    />
  )
}
